declare global {
  interface Window {
    __MH_REFRESH_COUNT__?: Record<string, number>;
    __MH_AUTH_TRIPWIRE_INSTALLED__?: boolean;
  }
}

function isDiagnosticsEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  return process.env.NEXT_PUBLIC_AUTH_DIAGNOSTICS === '1';
}

export function installAuthTripwire(): void {
  if (typeof window === 'undefined') return;
  if (!isDiagnosticsEnabled()) return;
  if (window.__MH_AUTH_TRIPWIRE_INSTALLED__) return;

  window.__MH_AUTH_TRIPWIRE_INSTALLED__ = true;
  window.__MH_REFRESH_COUNT__ = window.__MH_REFRESH_COUNT__ ?? {};

  const originalFetch = window.fetch;

  window.fetch = async (...args: Parameters<typeof fetch>) => {
    const response = await originalFetch(...args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0] as Request)?.url;
      if (url?.includes('/auth/v1/token') && url?.includes('grant_type=refresh_token')) {
        const pathname = window.location?.pathname || 'unknown';
        const counter = window.__MH_REFRESH_COUNT__ ?? {};
        counter[pathname] = (counter[pathname] ?? 0) + 1;
        window.__MH_REFRESH_COUNT__ = counter;
        console.warn('[MH Auth Tripwire] refresh_token request detected', {
          pathname,
          count: counter[pathname],
        });
        console.warn(new Error('MH refresh_token stack').stack);
      }
    } catch (error) {
      console.warn('[MH Auth Tripwire] Failed to inspect refresh_token request', error);
    }
    return response;
  };
}
